import {atom} from "recoil";
export const walletContractsPeriodState = atom({
  key: 'walletContractsPeriodState',
  default: [],
  effects: [
  ]
});
